/**
 * TEMU 手动「同步更新」配额 kind：每个按钮每天单独计次（店铺之间互不占用）。
 * 与后端 TemuManualSyncPaths 的路径映射保持一致。
 */

export function toTemuManualSyncQuotaKind(kind) {
  if (kind == null) return '';
  const s = String(kind).trim();
  if (!s) return '';
  return s
    .replace(/[_\s/]+/g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
}

export function resolveTemuManualSyncQuotaKindFromPath(path) {
  const p = String(path || '').split('?')[0];
  const m = p.match(/\/shops\/\d+\/(.+)$/);
  if (!m) return '';
  return buttonKeyForRest(m[1]);
}

function buttonKeyForRest(rest) {
  const r = String(rest || '');
  // 统一模块同步：kind 在请求头 / 点击上下文，不走路径
  if (r === 'module-sync-jobs' || r.startsWith('module-sync-jobs/')) return '';
  if (r.startsWith('products/')) return 'product';
  if (r.startsWith('shop-profile/')) return 'shop-profile';
  if (r.startsWith('sales-orders/')) return 'orders';
  if (r.startsWith('return-orders/') || r.startsWith('semi-aftersales/')) return 'return-orders';
  if (r.startsWith('quality-inspections/')) return 'quality-inspections';
  if (r.startsWith('certificate-library/')) return 'certificate-library';
  if (r.startsWith('certificates/')) return 'certificate';
  if (r.startsWith('finance/')) return 'finance';
  if (r.startsWith('stock/')) return 'stock';
  if (r.startsWith('pricing/reviews/')) return 'pricing-reviews';
  if (r.startsWith('pricing/adjusts/')) return 'pricing-adjusts';
  if (r.startsWith('compliance/agencies/')) return 'agency';
  if (r.startsWith('compliance/environmental-materials/')) return 'environmental';
  if (r.startsWith('compliance/skc-agency/')) return 'skc-agency';
  if (r.startsWith('compliance/')) return 'compliance';
  if (r.startsWith('discuss/')) return 'discuss';
  if (r.startsWith('rrp/audit/')) return 'rrp-audit';
  if (r.startsWith('rrp/')) return 'rrp-skc';
  if (r.startsWith('publish-records/')) return 'publish-record';
  if (r.startsWith('marketing/products/')) return 'marketing-product';
  if (r.startsWith('marketing/')) return 'marketing';
  return r
    .replace(/\/sync-jobs$/, '')
    .replace(/\/sync-job$/, '')
    .replace(/\/sync$/, '')
    .replace(/\//g, '-')
    || 'sync';
}
